<div class="sidenav-body-content">
  <router-outlet></router-outlet>
  <app-custom-notifications></app-custom-notifications>
</div>
